import { Grid, TextField } from "@mui/material";
import { useState } from "react";
import * as Yup from "yup";
import { Form, Formik, Field, ErrorMessage } from "formik";
import Notification from "../popup/Notification";
import ConfirmDialog from "../dialog/ConfirmDialog";
import Stack from "@mui/joy/Stack";
import Button from "@mui/joy/Button";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { LightTooltip } from "../tooltip/ToolTip";
import StringValidation from "../reusables/yupvalidation/StringValidation";

const AddLocation = (props) => {
  const { closeDialog, editLocation, selectedLocation } = props;

  var locationInfo = null;
  var locationId = "";
  var name = "";

  if (editLocation) {
    locationInfo = JSON.parse(selectedLocation);
    locationId = locationInfo.id;
    name = locationInfo.name;
  }

  const axiosPrivate = useAxiosPrivate();

  const resetForm = (props) => {
    // clear input fields
    props.resetForm();
  };

  const closeForm = (message) => {
    closeDialog(message);
  };

  const validationSchema = Yup.object().shape({
    name: StringValidation(2, 40),
  });

  // Common
  const initialValues = editLocation
    ? {
        name: name,
      }
    : {
        name: "",
      };

  function onSubmit(values, props) {
    props.setSubmitting(true);
    createLocation(values, props);
  }

  const LOCATIONS_URL = "/api/v1/locations/";
  const createLocation = async (values, props) => {
    // Common
    const data = {
      name: values.name,
    };

    try {
      const response = editLocation
        ? await axiosPrivate.put(LOCATIONS_URL + locationId, data, {
            headers: {
              "Content-Type": "application/json",
            },
          })
        : await axiosPrivate.post(LOCATIONS_URL + "save", data, {
            headers: {
              "Content-Type": "application/json",
            },
          });

      //console.log(response.data.message);
      props.setSubmitting(false);
      resetForm(props);
      closeForm(response.data.message);
    } catch (error) {
      props.setSubmitting(false);
      var errorMessage = "";
      if (error.response) {
        // The client was given an error response (5xx, 4xx)
        const errorData = error.response.data;
        errorMessage = errorData.message;
      } else if (error.request) {
        // The client never received a response, and the request was never left
        errorMessage = "No server response";
      } else {
        // Anything else
        errorMessage = "Unexpected error occurred";
      }
      const errorTitle = editLocation ? "Update" : "Create";
      setConfirmDialog({
        isOpen: true,
        title: `Failed To ${errorTitle} Location`,
        subTitle: errorMessage,
        action: "Retry",
        onConfirm: { onSubmit },
      });
    }
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  return (
    <Grid>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form>
            <Stack spacing={2} mt={3} direction="column">
              <Field
                as={TextField}
                label="Name"
                name="name"
                placeholder="Enter name"
                fullWidth
                required
                helperText={
                  <ErrorMessage name="name">
                    {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                  </ErrorMessage>
                }
              />
            </Stack>

            <Stack spacing={2} mt={3} direction="row" justifyContent="flex-end">
              <LightTooltip title="Clear form">
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: 8,
                    width: 120,
                    backgroundColor: "#808080",
                    padding: "7px 14px",
                    fontSize: "14px",
                    color: "white",
                    ":hover": {
                      bgcolor: "#696969",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    resetForm(props);
                  }}
                >
                  Reset
                </Button>
              </LightTooltip>

              <LightTooltip title="Submit details">
                <Button
                  loading={props.isSubmitting}
                  loadingPosition="start"
                  disabled={props.isSubmitting}
                  type="submit"
                  sx={{
                    width: 120,
                  }}
                  variant="solid"
                >
                  {props.isSubmitting ? "Submitting" : "Submit"}
                </Button>
              </LightTooltip>
            </Stack>
          </Form>
        )}
      </Formik>

      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </Grid>
  );
};

export default AddLocation;
